import React, { useState, useEffect } from "react";
import Select, { ActionMeta, SingleValue } from "react-select";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";

import index from "@beeldit/core/services";
import { Customer } from "../models/Customer";

interface Option {
  label: string;
  value: number | string;
}

function CustomSelectWidget(props: any) {
  const { id, value, required, disabled, readonly, onChange, formContext } = props;
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [options, setOptions] = useState<Option[]>([]);
  const [elementsData, setElementsData] = useState({ elements: [] });

  const { element, setElement } = formContext;

  const errorHandler = useErrorHandler();

  useEffect(() => {
    index("customers", "")
      .then((response: any) => {
        setElementsData(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, null);
      });
  }, []);
  useEffect(() => {
    const options = elementsData.elements.map((customer: Customer) => {
      const label = customer.name + ' ' + customer.first_lastname + ' - ' + customer.nif;
      return { label: label, value: customer.id };
    });
    setOptions(options);
    const currentSelectedOption = options.find(
      (option) => option.value === value
    );
    setSelectedOption(currentSelectedOption || null);
  }, [elementsData, value]);

  const handleOnChange = (
    newValue: SingleValue<Option>,
    actionMeta: ActionMeta<Option>
  ) => {
    const selectedOption = newValue as Option | null;
    setSelectedOption(selectedOption);
    const model = selectedOption?.value ?? null;
    onChange(model);
  };

  const selectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: "#E7F5F2",
      backgroundColor: "#E7F5F2",
      borderRadius: "0.25rem",
    }),
  };  

  const disabledByreadOnly = () => {
    if (typeof readonly === 'function') {
      return readonly(element);
    }
    return readonly;
  }

  return (
    <>
    <Select
      id={id}
      options={options}
      value={selectedOption}
      required={required}
      isDisabled={disabled || disabledByreadOnly()}
      onChange={handleOnChange}
      styles={selectStyles}
      placeholder="Selecciona un cliente"
      isClearable={true}
    />
    </>
  );
}

function CustomerSelector(props: any) {
  const { id, options, value, required, disabled, readonly, onChange, formContext } = props;
  return (
    <CustomSelectWidget
      id={id}
      options={options.enumOptions}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
      formContext={formContext}
    />
  );
}

export default CustomerSelector;
